import { Typography } from "@mui/material";
import CustomStatusChip from "@/components/custom/custom-status-chip";
import { formatCurrency } from "@/utils/format-currency";
import { formatDateTime } from "@/utils/format-date";
import { ACTIVE_STATUS_STYLES, toActiveStatus } from "../../data";

export const getChargeColumns = ({ onToggle }) => [
  {
    accessorKey: "fee",
    header: () => <div style={{ whiteSpace: "nowrap" }}>Fee per SMS</div>,
    cell: ({ row }) => (
      <Typography fontSize="0.85rem" fontWeight={600}>
        {row.original.fee != null ? formatCurrency(row.original.fee, "NGN") : "N/A"}
      </Typography>
    ),
  },
  {
    accessorKey: "active",
    header: () => <div style={{ whiteSpace: "nowrap" }}>Status</div>,
    cell: ({ row }) => (
      <CustomStatusChip
        status={toActiveStatus(row.original.active)}
        styles={ACTIVE_STATUS_STYLES}
      />
    ),
  },
  {
    accessorKey: "created_at",
    header: () => <div style={{ whiteSpace: "nowrap" }}>Created</div>,
    cell: ({ row }) => (
      <div style={{ fontSize: "0.8rem", whiteSpace: "nowrap" }}>
        {formatDateTime(row.original.created_at)}
      </div>
    ),
  },
  {
    accessorKey: "updated_at",
    header: () => <div style={{ whiteSpace: "nowrap" }}>Last Updated</div>,
    cell: ({ row }) => (
      <div style={{ fontSize: "0.8rem", whiteSpace: "nowrap" }}>
        {formatDateTime(row.original.updated_at)}
      </div>
    ),
  },
  {
    id: "actions",
    header: () => <div style={{ whiteSpace: "nowrap" }}>Action</div>,
    cell: ({ row }) => (
      <Typography
        onClick={(e) => { e.stopPropagation(); onToggle?.(row.original); }}
        sx={{
          fontSize: "0.82rem",
          fontWeight: 600,
          color: row.original.active ? "error.main" : "success.main",
          cursor: "pointer",
          whiteSpace: "nowrap",
        }}
      >
        {row.original.active ? "Deactivate" : "Activate"}
      </Typography>
    ),
  },
];